import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled, { keyframes } from 'styled-components';

import { makeImagePreviewable, useLocalizedLogoRibbon } from '../utils';

import Block from './Block';

const slide = (nrOfLogos) => keyframes`
  from {
    transform: translateX(0px);
  }

  to {
    transform: translateX(calc(-60px * ${nrOfLogos} * 2));
  }
`;

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

const AnimationLayer = styled.div`
  display: flex;
  align-items: center;
  animation: ${(props) => slide(props.nrOfLogos)} 70s linear;
  animation-iteration-count: infinite;
`;

const LogoImage = styled.img`
  filter: grayscale(1);
  margin: ${({ theme }) =>
    `${theme.spacing.baseDown1} ${theme.spacing.baseDown2}`};
`;

const PageLogoRibbon = ({ selectedLocale }) => {
  const [logoRibbon] = useLocalizedLogoRibbon(selectedLocale);

  return (
    <Block backgroundColor="grayLight">
      <Wrapper>
        <AnimationLayer nrOfLogos={logoRibbon.node.data.logos.length}>
          {logoRibbon.node.data.logos.map((item) => {
            const logo = makeImagePreviewable(item.logo);

            return (
              <LogoImage
                key={`logo-item-${logo.localFile.id}`}
                src={logo.localFile.childImageSharp.fixed.src}
                srcSet={logo.localFile.childImageSharp.fixed.srcSet}
              />
            );
          })}

          {logoRibbon.node.data.logos.map((item) => {
            const logo = makeImagePreviewable(item.logo);

            return (
              <LogoImage
                key={`logo-item-${logo.localFile.id + 1}`}
                src={logo.localFile.childImageSharp.fixed.src}
                srcSet={logo.localFile.childImageSharp.fixed.srcSet}
              />
            );
          })}
        </AnimationLayer>
      </Wrapper>
    </Block>
  );
};

PageLogoRibbon.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
};

export default PageLogoRibbon;

export const query = graphql`
  fragment LogoRibbonFragment on PrismicLogoRibbon {
    lang
    data {
      logos {
        logo {
          localFile {
            id
            childImageSharp {
              fixed(height: 30) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
    }
  }
`;
